module.exports = __webpack_public_path__ + "static/media/belo.93a84dfc.jpg";